import {Link} from "react-router-dom";

export function NavLink (props){
    return(
        <Link className={"align-self-center text-decoration-none text-white"} to={props.to}>
            {props.children}
        </Link>
    )

}